<template>
  <div>
    <!-- Sidebar: Approve -->
    <b-sidebar
      id="approve-sidebar"
      v-model="visibility"
      bg-variant="white"
      backdrop
      shadow
      no-header
      right
      class="resource-sidebar"
    >
      <!-- Approve Sidebar Header -->
      <div class="sb-header sb-header--approve">
        <div class="sb-header__top">
          <div class="sb-header__badge">
            <feather-icon icon="CheckCircleIcon" size="14" />
            <span>Approve Request</span>
          </div>
          <b-button variant="flat-secondary" size="sm" class="sb-close-btn" @click="visibility = false">
            <feather-icon icon="XIcon" size="16" />
          </b-button>
        </div>
        <div class="sb-header__profile">
          <b-avatar size="52" variant="light-success" :text="sidebarInitials" class="sb-avatar" />
          <div class="sb-header__info">
            <h5 class="sb-header__name" v-html="sidebarTitle"></h5>
          </div>
        </div>
      </div>

      <!-- Approve Sidebar Body -->
      <div class="sb-body">
        <RequestDetails :reqItem="approveObj" />

        <!-- Divider -->
        <div class="sb-divider">
          <span>Action</span>
        </div>

        <b-form @submit.prevent>
          <div class="sb-form-field">
            <label class="sb-label">
              <feather-icon icon="CalendarIcon" size="13" class="mr-50" />
              Leaving Date
            </label>
            <flat-pickr
              :config="config"
              v-model="approveObj.leavingDate"
              class="form-control sb-input"
              :placeholder="$t('Select Date')"
              ref="date"
            />
          </div>

          <div class="sb-form-field" ref="note">
            <label class="sb-label">
              <feather-icon icon="FileTextIcon" size="13" class="mr-50" />
              Note
            </label>
            <b-form-textarea
              placeholder="Write a short approval note..."
              rows="3"
              v-model.trim="approveObj.note"
              class="sb-textarea"
            />
          </div>

          <b-button
            variant="success"
            :disabled="request"
            block
            class="sb-action-btn sb-action-btn--approve"
            @click="approveReq()"
          >
            <b-spinner v-if="request" small type="grow" class="mr-50" />
            <feather-icon v-else icon="CheckIcon" size="16" class="mr-50" />
            <span>{{ request ? 'Processing...' : 'Approve Request' }}</span>
          </b-button>
        </b-form>
      </div>
    </b-sidebar>

    <!-- Sidebar: Reject -->
    <b-sidebar
      id="reject-sidebar"
      v-model="visibility2"
      bg-variant="white"
      backdrop
      shadow
      no-header
      right
      class="resource-sidebar"
    >
      <!-- Reject Sidebar Header -->
      <div class="sb-header sb-header--reject">
        <div class="sb-header__top">
          <div class="sb-header__badge sb-header__badge--danger">
            <feather-icon icon="XCircleIcon" size="14" />
            <span>Reject Request</span>
          </div>
          <b-button variant="flat-secondary" size="sm" class="sb-close-btn" @click="visibility2 = false">
            <feather-icon icon="XIcon" size="16" />
          </b-button>
        </div>
        <div class="sb-header__profile">
          <b-avatar size="52" variant="light-danger" :text="sidebarInitials" class="sb-avatar" />
          <div class="sb-header__info">
            <h5 class="sb-header__name" v-html="sidebarTitle"></h5>
          </div>
        </div>
      </div>

      <!-- Reject Sidebar Body -->
      <div class="sb-body">
        <RequestDetails :reqItem="rejectObj" />

        <div class="sb-divider">
          <span>Action</span>
        </div>

        <b-form @submit.prevent>
          <div class="sb-form-field" ref="rej_note">
            <label class="sb-label">
              <feather-icon icon="MessageSquareIcon" size="13" class="mr-50" />
              Rejection Reason
            </label>
            <b-form-textarea
              placeholder="Explain why this request is being rejected..."
              rows="4"
              v-model.trim="rejectObj.note"
              class="sb-textarea"
            />
          </div>

          <b-button
            variant="danger"
            :disabled="request"
            block
            class="sb-action-btn sb-action-btn--reject"
            @click="rejectReq()"
          >
            <b-spinner v-if="request" small type="grow" class="mr-50" />
            <feather-icon v-else icon="SlashIcon" size="16" class="mr-50" />
            <span>{{ request ? 'Processing...' : 'Reject Request' }}</span>
          </b-button>
        </b-form>
      </div>
    </b-sidebar>

    <!-- Sidebar: Details -->
    <b-sidebar
      id="details-sidebar"
      v-model="visibility3"
      bg-variant="white"
      backdrop
      shadow
      no-header
      right
      class="resource-sidebar"
    >
      <!-- Details Sidebar Header -->
      <div class="sb-header sb-header--view">
        <div class="sb-header__top">
          <div class="sb-header__badge sb-header__badge--info">
            <feather-icon icon="EyeIcon" size="14" />
            <span>Request Details</span>
          </div>
          <b-button variant="flat-secondary" size="sm" class="sb-close-btn" @click="visibility3 = false">
            <feather-icon icon="XIcon" size="16" />
          </b-button>
        </div>
        <div class="sb-header__profile">
          <b-avatar size="52" variant="light-primary" :text="sidebarInitials" class="sb-avatar" />
          <div class="sb-header__info">
            <h5 class="sb-header__name" v-html="sidebarTitle"></h5>
          </div>
        </div>
      </div>

      <!-- Details Sidebar Body -->
      <div class="sb-body">
        <RequestDetails v-if="detailObj" :reqItem="detailObj" />
      </div>
    </b-sidebar>


    <b-card class="staff-requests-list-card">
      <div class="gradient-line-wrapper"></div>
      <div class="table-header d-flex flex-wrap justify-content-between align-items-center mb-2">
        <div>
          <h5 class="mb-0 resource-title">Staff Requests</h5>
          <small class="text-muted">Manage and review staff requests</small>
        </div>
      </div>

      <!-- Pagination Controls - Top (Compact Single Line) -->
      <div class="pagination-controls-top d-flex justify-content-between align-items-center mb-2">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <!-- Page Size Dropdown -->
          <div class="page-size-wrapper">
            <label class="page-size-label">Show:</label>
            <v-select
              :key="'page-size-' + pageSize"
              v-model="pageSize"
              :options="pageSizeOptions"
              :reduce="option => option.value"
              label="label"
              :clearable="false"
              :searchable="false"
              append-to-body
              class="page-size-select-compact"
              @input="onPageSizeChange"
              ref="pageSizeSelect"
            />
          </div>
        </div>
        
        <!-- Count Display in Middle -->
        <div class="pagination-count-display">
          <span class="count-text">
            Showing <strong>{{ displayedRange.start }}</strong> to <strong>{{ displayedRange.end }}</strong> of <strong>{{ totalCount }}</strong>
          </span>
        </div>
        
        <!-- Pagination -->
        <div class="pagination-wrapper-compact">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalCount"
            :per-page="pageSize"
            size="sm"
            align="center"
            class="pagination-compact"
            @change="onPageChange"
          />
        </div>
      </div>

      <b-row class="align-items-center filter-row mb-2">
        <b-col md="3" class="mb-1 mb-md-0">
          <b-input-group class="filter-control">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              v-model="searchQuery"
              placeholder="Search by Name & ID"
              class="border-left-0"
              @input="onSearchChange"
              debounce="500"
            />
          </b-input-group>
        </b-col>
        <b-col md="3" class="mb-1 mb-md-0">
          <v-select
            v-model="currentStatus"
            :options="statusOptions"
            :reduce="val => val.value"
            label="text"
            :clearable="false"
            class="filter-control"
            placeholder="Filter by Status"
            @input="LoadData(currentStatus)"
          />
        </b-col>
        <b-col md="2" class="mb-1 mb-md-0">
          <flat-pickr
            v-model="fromDate"
            :config="config"
            class="form-control filter-control"
            placeholder="From Date"
            @input="LoadData(currentStatus)"
          />
        </b-col>
        <b-col md="2" class="mb-1 mb-md-0">
          <flat-pickr
            v-model="toDate"
            :config="config"
            class="form-control filter-control"
            placeholder="To Date"
            @input="LoadData(currentStatus)"
          />
        </b-col>
        <b-col md="2">
          <b-button variant="gradient-primary" block @click="printReport" class="action-btn-filter">
            <feather-icon icon="PrinterIcon" class="mr-50" />
            <span>Print</span>
          </b-button>
        </b-col>
      </b-row>

      <div class="table-scroll-container">
        <!-- Top Scrollbar for PC -->
        <div class="table-scrollbar-top" ref="topScrollbar">
          <div class="table-scrollbar-content"></div>
        </div>
        
        <!-- Table Wrapper -->
        <div class="table-wrapper" ref="tableWrapper" @scroll="syncScroll">
          <b-table
            class="staff-requests-table mt-1"
            thead-tr-class="adjust-head"
            ref="selectableTable"
            :items="paginatedItems"
            :fields="fields"
            :busy="dataLoading"
            show-empty
            :responsive="false"
            hover
            small
          >
        <template #empty>
          <h3 class="mt-1 mb-1 text-center">No records found</h3>
        </template>

        <template #table-busy>
          <tbody>
            <tr v-for="n in 5" :key="'skeleton-' + n" class="skeleton-row">
              <td v-for="(field, index) in fields" :key="'skeleton-cell-' + index" class="skeleton-cell">
                <div class="skeleton-loader"></div>
              </td>
            </tr>
          </tbody>
        </template>

        <template #cell(index)="data">
          {{ (currentPage - 1) * pageSize + data.index + 1 }}
        </template>

        <template #cell(name)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="44"
                :src="data.item.st.picture"
                variant="light-primary"
              />
            </template>

            <b-link
              class="font-weight-bold d-block text-nowrap"
              style="margin-bottom: 4px"
            >
              <span class="text-primary font-weight-bolder">
                {{ data.item.st.name }}
              </span>
            </b-link>
            <b-link
              class="font-weight-bold d-block text-nowrap"
              style="margin-bottom: 4px"
            >
              <small class="text-muted">F/N: {{ data.item.st.father_name }}</small>
            </b-link>
            <small class="text-muted">
              <b-badge variant="light-primary" class="mr-50">
                ID: {{ data.item.st.id }}
              </b-badge>
              <b-badge variant="light-primary">
                RFID: {{ data.item.st.rfID }}
              </b-badge>

              <b-badge
                v-if="reportDomain == 'myskoolhpgs'"
                variant="light-primary"
                class="ml-50"
              >
                EMP# {{ data.item.st.empCode }}
              </b-badge>
            </small>
            <b-link
              v-if="
                data.item.st.status.toLowerCase() == 'left' &&
                data.item.st.leaving_date
              "
              class="font-weight-bold d-block text-nowrap"
              style="margin-top: 4px"
            >
              <small class="text-danger">
                Left on: {{
                  new Date(data.item.st.leaving_date).toLocaleDateString(
                    "en-UK",
                    {
                      year: "numeric",
                      day: "numeric",
                      month: "short",
                    }
                  )
                }}
              </small>
            </b-link>
            <b-link
              v-if="
                data.item.st.status.toLowerCase() == 'present' &&
                data.item.st.appointedOn
              "
              class="font-weight-bold d-block text-nowrap"
              style="margin-top: 4px"
            >
              <small class="text-success">
                Appointed: {{
                  new Date(data.item.st.appointedOn).toLocaleDateString(
                    "en-UK",
                    {
                      year: "numeric",
                      day: "numeric",
                      month: "short",
                    }
                  )
                }}
              </small>
            </b-link>
          </b-media>
        </template>

        <template #cell(campusName)="data">
          <b-badge variant="light-primary" v-if="data.item.us && data.item.us.metaCampusName">
            {{ data.item.us.metaCampusName }}
          </b-badge>
          <b-badge variant="light-secondary" v-else-if="data.item.st && data.item.st.campusID">
            {{ getCampus(data.item.st.campusID) }}
          </b-badge>
          <b-badge variant="light-secondary" v-else>
            N/A
          </b-badge>
        </template>
        <template #cell(designation)="data">
          <b-badge variant="light-primary">
            {{ data.item.st.designation }}
          </b-badge>
        </template>
        <template #cell(contact_number)="data">
          <b-badge variant="light-primary">
            {{ data.item.st.contact_number }}
          </b-badge>
        </template>

        <template #cell(status)="data">
          <b-badge :variant="getStatusVariant(data.item.us.status)" class="text-capitalize">
            {{ data.item.us.status }}
          </b-badge>
        </template>

        <template #head(actions)="data">
          <div class="text-center">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="d-flex justify-content-center">
            <b-button
              variant="gradient-primary"
              class="action-btn-table mr-1"
              v-b-tooltip.hover.top
              title="View Details"
              @click="openDetails(data.item.us, data.item.st)"
            >
              <feather-icon icon="EyeIcon" size="16" />
            </b-button>
            <template v-if="data.item.us.status == 'pending'">
              <b-button
                variant="outline-success"
                class="action-btn-outline edit-btn mr-1"
                v-b-tooltip.hover.top
                title="Approve"
                @click="openApprove(data.item.us, data.item.st)"
              >
                <feather-icon icon="CheckIcon" size="16" />
              </b-button>
              <b-button
                variant="outline-danger"
                class="action-btn-outline delete-btn"
                v-b-tooltip.hover.top
                title="Reject"
                @click="openReject(data.item.us, data.item.st)"
              >
                <feather-icon icon="XIcon" size="16" />
              </b-button>
            </template>
          </div>
        </template>
          </b-table>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BPagination,
  VBTooltip,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";
import { getUploadedPaths, uploadToMySkool } from "@/utils/gdriveUpload";
import RequestDetails from "./RequestDetails.vue";

export default {
  components: {
    RequestDetails,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BForm,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BInputGroup,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      rights: {},
      statusOptions: [
        { text: "All Requests", value: "all" },
        { text: "Pending", value: "pending" },
        { text: "Accepted", value: "accepted" },
        { text: "Rejected", value: "rejected" },
      ],
      campuses: [],
      dataLoading: false,
      currentStatus: "all",
      items: [],
      fields: [
        { label: "S.No", key: "index" },
        { label: "name", key: "name" },
        { label: "Campus Name", key: "campusName" },
        { label: "designation", key: "designation" },
        { label: "contact", key: "contact_number" },
        { label: "status", key: "status" },
        "actions",
      ],
      request: false,
      sidebarTitle: "",
      visibility: false,
      approveObj: {},
      docLoading: false,
      docList: [],
      visibility2: false,
      rejectObj: {},
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      visibility3: false,
      detailObj: null,
      currentStd: {},
      searchQuery: "",
      searchTimeout: null,
      fromDate: null,
      toDate: null,
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
      pageSizeOptions: [
        { label: "10", value: 10 },
        { label: "20", value: 20 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
      ],
    };
  },
  computed: {
    displayedRange() {
      if (this.totalCount === 0) {
        return { start: 0, end: 0 };
      }
      const start = (this.currentPage - 1) * this.pageSize + 1;
      const end = Math.min(this.currentPage * this.pageSize, this.totalCount);
      return { start, end };
    },
    totalItemsCount() {
      return this.totalCount;
    },
    paginatedItems() {
      // Server-side pagination: API already returns the current page slice
      return this.items;
    },
    sidebarInitials() {
      // Extract initials from sidebarTitle (strip HTML tags first)
      const cleanText = this.sidebarTitle.replace(/<[^>]*>/g, ' ').trim();
      const parts = cleanText.split(/[\s\-]+/).filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
      return 'ST';
    },
  },
  created() {
    // let right = {};
    // this.$store.state.menu.forEach((el) => {
    //   el.children.forEach((ch) => {
    //     right[ch.route] = {
    //       view: ch.view,
    //       add: ch.add,
    //       edit: ch.edit,
    //       delete: ch.delete,
    //       hideFee: ch.hideFee,
    //       editCampus: ch.editCampus,
    //       disableImport: ch.disableImport,
    //       disableExport: ch.disableExport,
    //     };
    //   });
    // });
    // // console.log(right);
    // this.$store.commit("setRights", right);

    // if (!this.$store.state.rights[this.$route.name]) {
    //   // console.log(this.$store.state.rights[this.$route.name]);
    //   this.$router.replace({
    //     name: "misc-not-authorized",
    //   });
    // } else {
    //   this.rights = this.$store.state.rights[this.$route.name];
    // }

    // if (this.reportDomain == "myskoolhpgs") {
    //   this.fields.splice(3, 0, { label: "campus", key: "campus" });
    // }
    // this.LoadCampuses();
    this.LoadData("all");
  },
  mounted() {
    this.updateScrollbarWidth();
    window.addEventListener('resize', this.updateScrollbarWidth);
  },
  updated() {
    this.updateScrollbarWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollbarWidth);
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    onPageChange(page) {
      this.currentPage = page;
      // Reload data from paginated API when page changes
      this.LoadData(this.currentStatus);
      this.$nextTick(() => {
        this.updateScrollbarWidth();
      });
    },

    onPageSizeChange() {
      this.currentPage = 1;
      // Reload data from paginated API when page size changes
      this.LoadData(this.currentStatus);
      this.$nextTick(() => {
        this.updateScrollbarWidth();
      });
    },

    onSearchChange() {
      // Clear previous timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Debounce search to avoid too many API calls
      this.searchTimeout = setTimeout(() => {
        // Server-side search: reset to first page and reload
        this.currentPage = 1;
        this.LoadData(this.currentStatus);
      }, 500);
    },

    syncScroll() {
      if (this.$refs.tableWrapper && this.$refs.topScrollbar) {
        const tableWrapper = this.$refs.tableWrapper;
        const topScrollbar = this.$refs.topScrollbar;
        const scrollContent = topScrollbar.querySelector('.table-scrollbar-content');
        
        if (scrollContent) {
          topScrollbar.scrollLeft = tableWrapper.scrollLeft;
        }
      }
    },

    updateScrollbarWidth() {
      this.$nextTick(() => {
        if (this.$refs.tableWrapper && this.$refs.topScrollbar) {
          const tableWrapper = this.$refs.tableWrapper;
          const topScrollbar = this.$refs.topScrollbar;
          const scrollContent = topScrollbar.querySelector('.table-scrollbar-content');
          
          if (scrollContent) {
            if (tableWrapper.scrollWidth > tableWrapper.clientWidth) {
              scrollContent.style.width = `${tableWrapper.scrollWidth}px`;
              topScrollbar.style.display = 'block';
              
              // Ensure bit-directional sync
              topScrollbar.onscroll = () => {
                tableWrapper.scrollLeft = topScrollbar.scrollLeft;
              };
            } else {
              topScrollbar.style.display = 'none';
            }
          }
        }
      });
    },

    getStatusVariant(status) {
      if (status == "pending") return "light-warning";
      if (status == "accepted") return "light-success";
      if (status == "rejected") return "light-danger";
      return "light-primary";
    },

    isImage(url) {
      return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/i.test(url);
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    getCampus(id) {
      let obj = this.campuses.find((el) => el.id == id);
      return obj ? obj.branch : "";
    },

    openApprove(item, std) {
      this.approveObj = { ...item };
      this.currentStd = { ...std };
      // if (item.approved_document)
      //   this.docList = item.approved_document.split(",");
      // else this.docList = [];

      let dt = std.appointedOn
        ? new Date(std.appointedOn).toLocaleDateString("en-UK", {
            year: "numeric",
            day: "numeric",
            month: "short",
          })
        : "";
      this.sidebarTitle = `${std.name} - ${std.designation}<br/>${dt}`;
      this.visibility = true;
    },
    async addDoc() {
      if (this.$refs.reqDocs.files.length > 0) {
        let docs = this.$refs.reqDocs.files;
        this.docLoading = true;
        try {
          const uploaded = await uploadToMySkool(docs);
          getUploadedPaths(uploaded).forEach((path) => {
            this.docList.push(path);
          });
          this.approveObj.approved_document = this.docList.join(",");
        } catch (err) {
          console.log(err);
        } finally {
          this.docLoading = false;
        }
      }
    },
    removeDoc(index) {
      this.docList.splice(index, 1);
      this.approveObj.approved_document = this.docList.join(",");
    },
    CheckDate() {
      var elem = this.$refs["date"];
      if (!this.approveObj.leavingDate) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckNote() {
      var elem = this.$refs["note"];
      if (this.approveObj.note.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async approveReq() {
      if (this.CheckDate() == true && this.CheckNote() == true) {
        let obj = { ...this.approveObj };
        obj.status = "accepted";
        obj.approvedBy = this.$store.state.userData.userID;
        // console.log(obj);

        this.request = true;
        var status = await this.put({
          url:
            this.$store.state.domain +
            "StaffRequests/" +
            obj.id +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            obj.campusID,
          body: obj,
          message: `Request approved successfully!`,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.LoadData(this.currentStatus);
          this.visibility = false;
        }
      }
    },
    openReject(item, std) {
      this.rejectObj = { ...item };

      let dt = std.appointedOn
        ? new Date(std.appointedOn).toLocaleDateString("en-UK", {
            year: "numeric",
            day: "numeric",
            month: "short",
          })
        : "";
      this.sidebarTitle = `${std.name} - ${std.designation}<br/>${dt}`;
      this.visibility2 = true;
    },
    CheckReason() {
      var elem = this.$refs["rej_note"];
      if (this.rejectObj.note.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async rejectReq() {
      if (this.CheckReason() == true) {
        let obj = { ...this.rejectObj };
        obj.status = "rejected";
        obj.leavingDate = new Date().toJSON();
        obj.approvedBy = this.$store.state.userData.userID;
        // console.log(obj);

        this.request = true;
        var status = await this.put({
          url:
            this.$store.state.domain +
            "StaffRequests/" +
            obj.id +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            obj.campusID,
          body: obj,
          message: `Request rejected successfully!`,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.LoadData(this.currentStatus);
          this.visibility2 = false;
        }
      }
    },
    openDetails(item, std) {
      this.detailObj = { ...item };

      let dt = std.appointedOn
        ? new Date(std.appointedOn).toLocaleDateString("en-UK", {
            year: "numeric",
            day: "numeric",
            month: "short",
          })
        : "";
      this.sidebarTitle = `${std.name} - ${std.designation}<br/>${dt}`;
      this.visibility3 = true;
    },

    async LoadData(st) {
      if (typeof st === "string") {
        this.currentStatus = st;
      }

      this.dataLoading = true;
      try {
        // Build paginated URL (backend returns meta like totalCount, page, pageSize)
        // Use GetByPagination just like other modules (leaveRequest, resources, etc.)
        let url = this.$store.state.domain + "StaffRequests/LoadData?";

        const params = new URLSearchParams();
        params.append("db", this.$store.state.userData.db);
        params.append("cID", this.$store.state.userData.cId);
        params.append("status", this.currentStatus || "all");
        params.append("page", this.currentPage);
        params.append("pageSize", this.pageSize);

        // Optional search parameter (server-side)
        if (this.searchQuery && this.searchQuery.trim() !== "") {
          params.append("search", this.searchQuery.trim());
        }

        if (this.fromDate) {
          let fDate = new Date(this.fromDate);
          fDate.setHours(0, 0, 0, 0);
          params.append("requestedFrom", fDate.toJSON().substring(0, 19));
        }
        
        if (this.toDate) {
          let tDate = new Date(this.toDate);
          tDate.setHours(23, 59, 59, 999);
          params.append("requestedTo", tDate.toJSON().substring(0, 19));
        }

        url += params.toString();

        const res = await this.get({
          url,
          token: this.$store.state.userData.token,
          dashboard: true,
        });

        // The response format might be nested depending on the backend implementation
        let items = [];
        let totalCount = 0;
        let totalPages = 0;

        if (res && res.data && res.data.data) {
          // Format 1: { status: "success", data: { data: [...], totalRecords: 20 } }
          items = Array.isArray(res.data.data) ? res.data.data : [];
          totalCount = res.data.totalCount || res.data.totalRecords || items.length;
          totalPages = res.data.totalPages || Math.ceil(totalCount / this.pageSize);
        } else if (res && res.data && Array.isArray(res.data)) {
          // Format 2: { status: "success", data: [...], totalCount: 20 }
          items = res.data;
          totalCount = res.totalCount || res.totalRecords || items.length;
          totalPages = res.totalPages || Math.ceil(totalCount / this.pageSize);
        } else if (res && Array.isArray(res)) {
          // Format 3: [...]
          items = res;
          totalCount = items.length;
          totalPages = Math.ceil(totalCount / this.pageSize);
        } else {
          // Fallback
          items = [];
          totalCount = 0;
          totalPages = 0;
        }

        this.items = items;
        this.totalCount = totalCount || items.length || 0;
        this.totalPages = totalPages || Math.ceil(this.totalCount / this.pageSize) || 1;
      } catch (error) {
        // Fallback to empty data on error
        this.items = [];
        this.totalCount = 0;
        this.totalPages = 0;
        // Optional: log error for debugging
        // console.error("Error loading staff requests:", error);
      } finally {
        this.dataLoading = false;
      }
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },
    printReport() {
      const url = this.$router.resolve({
        name: "staff-requests-print",
        query: {
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          status: this.currentStatus,
        },
      }).href;
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.staff-requests-list-card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.12);
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: visible;

  .gradient-line-wrapper {
    position: absolute;
    top: 0;
    left: 0.75rem;
    right: 0.75rem;
    width: calc(100% - 1.5rem);
    height: 5px;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 5px;
      background: linear-gradient(90deg, #7c5dfa 0%, #9d7aff 50%, #cbb9ff 100%);
    }
  }

  &:hover {
    box-shadow: 0 15px 40px rgba(115, 103, 240, 0.2);
    transform: translateY(-2px);
  }

  ::v-deep .v-select .vs__dropdown-toggle {
    border-radius: 10px !important;
    min-height: 42px !important;
    border: 1.5px solid #e0d8ff !important;
    background: #fff !important;
    transition: all 0.2s ease;

    &:hover {
      border-color: #b8a9ff !important;
    }
    
    &:focus-within {
      border-color: #7c5dfa !important;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1) !important;
    }
  }
}

.table-header {
  border-bottom: 2px solid #f0edff;
  padding-bottom: 1rem;
  
  .resource-title {
    font-size: 1.25rem;
    font-weight: 800;
    color: #2d1b69;
    letter-spacing: -0.3px;
  }
}

.filter-control {
  ::v-deep .form-control {
    height: 42px;
    border-radius: 10px;
    border: 1.5px solid #e0d8ff;
    
    &:focus {
      border-color: #7c5dfa;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
    }
  }

  ::v-deep .input-group-text {
    border-radius: 10px 0 0 10px;
    border: 1.5px solid #e0d8ff;
    border-right: none;
    background: #f8fafc;
    color: #7c5dfa;
  }
}

.action-btn-filter {
  height: 42px;
  font-weight: 600;
  border-radius: 10px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(124, 93, 250, 0.2);
  }
}

.staff-requests-table {
  margin-top: 1rem;
  border-radius: 12px;
  overflow: hidden;
  min-width: 100%;
  width: max-content;
  border: 1px solid #e5e7eb;

  ::v-deep th {
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: none;
    font-weight: 700;
    color: #1e293b;
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.5px;
    padding: 0.75rem 0.875rem;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 5;
    
    &::after {
      display: none;
    }
  }

  ::v-deep td {
    vertical-align: middle;
    border-top: 1px solid #f1f5f9;
    border-bottom: 1px solid #f8fafc;
    padding: 0.75rem 0.875rem;
    background: #ffffff;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    font-size: 0.875rem;
    color: #475569;
    white-space: nowrap;
  }

  ::v-deep tbody tr {
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    position: relative;
    border-left: 2px solid transparent;

    &:nth-child(even) {
      background: #f8fafc;
      td { background: #f8fafc; }
    }
    
    &:hover {
      background: #f3f0ff !important;
      border-left-color: #7c5dfa;
      td {
        background: #f3f0ff !important;
        color: #2d1b69;
      }
    }
  }
}

// =============================================
// Modern Sidebar Redesign
// =============================================
.resource-sidebar {
  ::v-deep .b-sidebar-body {
    padding: 0 !important;
    overflow-y: auto;
    background: #f8f9fc;
  }
  ::v-deep .b-sidebar {
    width: 420px !important;
    max-width: 100%;
  }
}

// ---- Sidebar Header ----
.sb-header {
  padding: 1.25rem 1.5rem 1.5rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
  }

  // approve variant
  &--approve {
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 60%, #bbf7d0 100%);
    border-bottom: 1px solid #bbf7d0;
    &::before { background: linear-gradient(90deg, #22c55e 0%, #4ade80 100%); }
    .sb-header__badge { background: rgba(34,197,94,0.12); color: #15803d; }
    .sb-avatar { box-shadow: 0 0 0 3px rgba(34,197,94,0.25); }
  }

  // reject variant
  &--reject {
    background: linear-gradient(135deg, #fff1f2 0%, #ffe4e6 60%, #fecdd3 100%);
    border-bottom: 1px solid #fecdd3;
    &::before { background: linear-gradient(90deg, #ef4444 0%, #f87171 100%); }
    .sb-header__badge--danger { background: rgba(239,68,68,0.12); color: #b91c1c; }
    .sb-avatar { box-shadow: 0 0 0 3px rgba(239,68,68,0.25); }
  }

  // details/view variant
  &--view {
    background: linear-gradient(135deg, #faf9ff 0%, #ede9fe 60%, #ddd6fe 100%);
    border-bottom: 1px solid #ddd6fe;
    &::before { background: linear-gradient(90deg, #7c5dfa 0%, #9d7aff 100%); }
    .sb-header__badge--info { background: rgba(124,93,250,0.12); color: #5b21b6; }
    .sb-avatar { box-shadow: 0 0 0 3px rgba(124,93,250,0.25); }
  }
}

.sb-header__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.sb-header__badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  background: rgba(34,197,94,0.12);
  color: #15803d;
}

.sb-close-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.7);
  border: 1px solid rgba(0,0,0,0.08);
  color: #64748b;
  transition: all 0.25s ease;
  backdrop-filter: blur(4px);

  &:hover {
    background: #fff;
    color: #1e293b;
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
}

.sb-header__profile {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.sb-avatar {
  flex-shrink: 0;
  font-size: 1.1rem !important;
  font-weight: 700 !important;
}

.sb-header__info {
  flex: 1;
  min-width: 0;
}

.sb-header__name {
  font-size: 1rem;
  font-weight: 800;
  color: #1e293b;
  line-height: 1.35;
  margin: 0;
  word-break: break-word;

  ::v-deep br {
    display: block;
    content: '';
    margin-top: 2px;
  }
}

// ---- Sidebar Body ----
.sb-body {
  padding: 1.5rem;
  background: #f8f9fc;
  min-height: calc(100vh - 160px);
}

// ---- Divider ----
.sb-divider {
  display: flex;
  align-items: center;
  margin: 1.25rem 0;
  gap: 0.75rem;
  color: #94a3b8;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e2e8f0;
  }
}

// ---- Form Fields ----
.sb-form-field {
  margin-bottom: 1rem;
}

.sb-label {
  display: flex;
  align-items: center;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 0.4rem;
}

.sb-input {
  border-radius: 10px !important;
  border: 1.5px solid #e2e8f0 !important;
  height: 42px !important;
  background: #fff !important;
  transition: all 0.2s ease;
  font-size: 0.875rem;

  &:focus {
    border-color: #7c5dfa !important;
    box-shadow: 0 0 0 3px rgba(124,93,250,0.1) !important;
  }
}

.sb-textarea {
  border-radius: 10px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  resize: vertical;
  width: 100%;
  padding: 0.625rem 0.875rem;

  &:hover { border-color: #c4b5fd; }
  &:focus {
    border-color: #7c5dfa;
    box-shadow: 0 0 0 3px rgba(124,93,250,0.1);
    outline: none;
  }
}

// ---- Action Buttons ----
.sb-action-btn {
  border-radius: 12px;
  padding: 0.75rem;
  font-weight: 700;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  margin-top: 0.5rem;
  letter-spacing: 0.2px;

  &--approve {
    background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important;
    border: none !important;
    box-shadow: 0 4px 15px rgba(34,197,94,0.35);
    color: #fff !important;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(34,197,94,0.45);
    }
  }

  &--reject {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    border: none !important;
    box-shadow: 0 4px 15px rgba(239,68,68,0.35);
    color: #fff !important;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(239,68,68,0.45);
    }
  }

  &:active { transform: translateY(0) !important; }
  &:disabled { opacity: 0.65; cursor: not-allowed; }
}

.modern-btn-submit {
  border-radius: 12px;
  padding: 0.75rem 1.5rem;
  font-weight: 700;
  font-size: 0.95rem;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.2);
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(115, 103, 240, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
}


.action-btn-outline {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background: #fff !important;
  
  &.edit-btn {
    border: 2px solid #10b981 !important;
    color: #10b981 !important;
    &:hover {
      background: #f0fdf4 !important;
      transform: translateY(-2px);
    }
  }
  
  &.delete-btn {
    border: 2px solid #ef4444 !important;
    color: #ef4444 !important;
    &:hover {
      background: #fef2f2 !important;
      transform: translateY(-2px);
    }
  }
}

.action-btn-table {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(124, 93, 250, 0.3);
  }
}

.border-dashed {
  border: 1px solid var(--primary);
  border-style: dashed;
}

// Pagination Controls Styles
.pagination-controls-top {
  padding: 0.75rem 1.25rem;
  background: linear-gradient(180deg, #faf9ff 0%, #ffffff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.page-size-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  .page-size-label {
    font-size: 0.8125rem;
    font-weight: 600;
    color: #64748b;
    margin: 0;
  }
}

// Compact Page Size Select
.page-size-select-compact {
  min-width: 75px;
  width: 75px;
  
  ::v-deep .vs__dropdown-toggle {
    height: 32px !important;
    min-height: 32px !important;
    border-radius: 6px !important;
    border: 1.5px solid #e0d8ff !important;
    padding: 0 0.5rem !important;
    background: #fff !important;
    font-size: 0.8125rem !important;
    display: flex !important;
    align-items: center !important;
    
    &:hover {
      border-color: #b8a9ff !important;
    }
    
    &:focus-within {
      border-color: #7c5dfa !important;
      box-shadow: 0 0 0 2px rgba(124, 93, 250, 0.1) !important;
    }
  }
  
  ::v-deep .vs__selected-options {
    display: flex !important;
    align-items: center !important;
    padding: 0 !important;
  }
  
  ::v-deep .vs__selected {
    margin: 0 !important;
    padding: 0 !important;
    color: #2d1b69 !important;
    font-weight: 600 !important;
    font-size: 0.8125rem !important;
    line-height: 1 !important;
    display: flex !important;
    align-items: center !important;
    height: 100%;
    visibility: visible !important;
    opacity: 1 !important;
  }
  
  ::v-deep .vs__search {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  ::v-deep .vs__actions {
    padding: 0 0.25rem 0 0.5rem !important;
  }
  
  ::v-deep .vs__dropdown-menu {
    z-index: 99999 !important;
    position: fixed !important;
    min-width: 75px !important;
    width: 75px !important;
    border-radius: 8px !important;
    border: 1.5px solid #e0d8ff !important;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.15) !important;
    margin-top: 4px !important;
    background: #ffffff !important;
  }
}

.pagination-count-display {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 0 1rem;
  min-width: 200px;
  
  .count-text {
    font-size: 0.8125rem;
    color: #64748b;
    font-weight: 500;
    white-space: nowrap;
    
    strong {
      color: #2d1b69;
      font-weight: 700;
    }
  }
}

.pagination-wrapper-compact {
  display: flex;
  align-items: center;
  
  ::v-deep .pagination {
    margin-bottom: 0;
    
    .page-link {
      padding: 0.375rem 0.625rem;
      font-size: 0.8125rem;
      line-height: 1.5;
      border-radius: 6px;
      margin: 0 0.125rem;
      border: 1px solid #e0d8ff;
      color: #64748b;
      font-weight: 500;
      min-width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
      
      &:hover {
        background: #f3f0ff;
        border-color: #b8a9ff;
        color: #7c5dfa;
      }
    }
    
    .page-item.active .page-link {
      background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
      border-color: #7c5dfa;
      color: #fff;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(124, 93, 250, 0.3);
    }
    
    .page-item.disabled .page-link {
      background: #f8fafc;
      border-color: #e0d8ff;
      color: #cbd5e1;
      cursor: not-allowed;
    }
  }
}

// Table Wrapper for Horizontal Scroll
.table-scroll-container {
  position: relative;
  width: 100%;
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
  scrollbar-width: none; // Safari/Chrome handle below
  
  &::-webkit-scrollbar {
    display: none;
  }
}

// Top Scrollbar for PC Users
.table-scrollbar-top {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  height: 12px;
  margin-bottom: 8px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
  
  &::-webkit-scrollbar {
    height: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 6px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 6px;
    
    &:hover {
      background: #94a3b8;
    }
  }
  
  .table-scrollbar-content {
    height: 1px;
    width: 100%;
  }
  
  @media (max-width: 768px) {
    display: none;
  }
}

// Skeleton Loader Styles
.skeleton-row {
  animation: skeletonPulse 2s ease-in-out infinite;
  border-bottom: 1px solid #f1f5f9;
}

.skeleton-cell {
  padding: 1.25rem 1rem !important;
  background: #fff;
  vertical-align: middle;
  
  &:nth-child(1) .skeleton-loader { width: 40px; margin: 0 auto; } // S.No
  &:nth-child(2) .skeleton-loader { width: 220px; } // Name
  &:nth-child(3) .skeleton-loader { width: 120px; } // Designation
  &:nth-child(4) .skeleton-loader { width: 140px; } // Contact
  &:nth-child(5) .skeleton-loader { width: 100px; } // Status
  &:nth-child(6) .skeleton-loader { width: 80px; margin: 0 auto; } // Actions
}

.skeleton-loader {
  height: 18px;
  border-radius: 10px;
  background: linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 25%, #f0f0f0 50%, #f8f8f8 75%, #f0f0f0 100%);
  background-size: 300% 100%;
  animation: skeletonShimmer 2s ease-in-out infinite;
  width: 100%;
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0,0,0,0.03);

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%);
    animation: skeletonShine 2s ease-in-out infinite;
  }
}

@keyframes skeletonPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.85; transform: scale(0.998); }
}

@keyframes skeletonShimmer {
  0% { background-position: -300% 0; }
  100% { background-position: 300% 0; }
}

@keyframes skeletonShine {
  0% { left: -100%; }
  100% { left: 100%; }
}

@media (max-width: 992px) {
  .pagination-controls-top {
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: center;
    
    .pagination-count-display {
      order: 3;
      width: 100%;
      margin: 0.5rem 0 0 0;
      text-align: center;
    }
  }

  .bottom-pagination-row {
    flex-direction: column;
    gap: 1rem;
    align-items: center !important;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 12px;
    margin-top: 1.5rem !important;
    
    .count-display {
      order: 2;
      font-weight: 600;
    }
  }
}

@media (max-width: 768px) {
  .filter-row {
    > div {
      margin-bottom: 0.75rem;
    }
  }
  
  .staff-requests-list-card {
    padding: 1rem;
    border-radius: 15px;
  }
  
  .resource-title {
    font-size: 1.1rem !important;
  }
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
